import { useRef, useState } from 'react';
import { New_Subject } from '../../../api/api';
import axios from 'axios';
import useCategoryList from '../../../hooks/useCategoryList';
import usePlatformList from '../../../hooks/usePlatformList';
import useFeatureList from '../../../hooks/useFeatureList';
import { toast } from 'react-toastify';
import { useNavigate, useSearchParams } from 'react-router-dom';
import ProducerSideBar from './components/ProducerSideBar';
import CatsPost from './components/CatsPost';
import PlatformsPost from './components/PlatformsPost';
import FeaturesPost from './components/FeaturesPost';
import UploadPoster from './components/UploadPoster';
import PostContentTabs from './components/PostContentTabs';
import {
  buildSystemRequirementPayload,
  emptySystemRequirement,
} from './components/systemRequirementHelper';
import { hasComputerPlatformSelected } from './components/platformHelper';
import {
  SUBJECT_TYPES,
  buildVideosPayload,
  createEmptyVideo,
  sanitizeBranchModelsForSubmit,
} from './components/videoHelper';
import PendingPost from './components/PendingPost';
import RichTextEditor from './components/RichTextEditor';
import UploadGallery from './components/UploadGallery';


const mod = {
     toolbar: [
          ['bold', 'italic', 'underline', 'strike'],
          ['blockquote'],
          [{ 'header': 1 }, { 'header': 2 }],
          [{ 'list': 'ordered' }, { 'list': 'bullet' }],
          [{ 'direction': 'rtl' }],
          [{ 'size': ['small', false, 'large', 'huge'] }],
          [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
          [{ 'color': [] }, { 'background': [] }],
          [{ 'font': [] }],
          [{ 'align': [] }],
          ['clean', 'link']
     ],
}

const NewPost = () => {
     const [searchParams] = useSearchParams()
     const isVideo = searchParams.get('type') === 'video'
     const subjectType = isVideo ? SUBJECT_TYPES.VIDEO : SUBJECT_TYPES.GAME

     const [loading, setLoading] = useState(false);

     const [imageId, setImageId] = useState(null);
     const [imagesIds, setImagesIds] = useState([]);

     const [checkedState, setCheckedState] = useState([])
     const [platformIds, setPlatformIds] = useState([])
     const [features, setFeatures] = useState([])
     const [metadata, setMetadata] = useState(null)
     const [selectedOption, setSelectedOption] = useState(null)
     const CategoryList = useCategoryList()
     const PlatformList = usePlatformList()
     const FeatureList = useFeatureList()
     const [links, setLinks] = useState([])
     const [videos, setVideos] = useState([createEmptyVideo()])
     const [pendingPost, setPendingPost] = useState(0)
     const [publishDate, setPublishDate] = useState('')

     const [descriptions, setDescriptions] = useState('')
     const [updateInfo, setUpdateInfo] = useState('')
     const [installationGuide, setInstallationGuide] = useState('')
     const [minimumSystemRequirement, setMinimumSystemRequirement] = useState(emptySystemRequirement())
     const [recommendedSystemRequirement, setRecommendedSystemRequirement] = useState(emptySystemRequirement())

     const uploadFilesCode = useRef(null)

     const navigate = useNavigate()

     const showSystemRequirements = hasComputerPlatformSelected(platformIds, PlatformList)


     const handleSubmitForm = async (e) => {
          e.preventDefault()

          if (selectedOption && selectedOption !== null) {

               let videosPayload = null
               if (isVideo) {
                    const videosResult = buildVideosPayload(videos)
                    if (videosResult.error) {
                         toast.error(videosResult.error)
                         return
                    }
                    videosPayload = videosResult.payload
               }

               setLoading(true);

               //اپلود فایل های امینیتی قبل از ذخیره عنوان
               if (uploadFilesCode.current) {
                    await uploadFilesCode.current.preSubmitAction()
               }

               let data = {
                    type: subjectType,
                    videos: isVideo ? videosPayload : null,
                    categoryIds: checkedState ? checkedState : null,
                    platformIds: platformIds.length ? platformIds : null,
                    features: features.length ? features : null,
                    metadata: metadata?.length ? metadata : null,
                    title: e.target.isTitle.value ? e.target.isTitle.value : null,
                    persianTitle: e.target.persianTitle.value ? e.target.persianTitle.value : null,
                    producerUserId: selectedOption,
                    description: descriptions,
                    updateInfo: updateInfo || null,
                    installationGuide: installationGuide || null,
                    minimumSystemRequirement: showSystemRequirements
                         ? buildSystemRequirementPayload(minimumSystemRequirement)
                         : null,
                    recommendedSystemRequirement: showSystemRequirements
                         ? buildSystemRequirementPayload(recommendedSystemRequirement)
                         : null,
                    posterId: imageId ? imageId : null,
                    branchModels: sanitizeBranchModelsForSubmit(links, isVideo),
                    state: pendingPost,
                    size: e.target.size.value !== '' ? parseFloat(e.target.size.value) : null,
                    productionYear: e.target.publishDate.value ? e.target.publishDate.value : 0,
                    version: e.target.version.value,
                    publishDate: publishDate.replaceAll('/', '-').replace(' ', 'T'),
                    ages: e.target.age.value || null,
                    isPin: e.target.isPin.checked,
                    GalleryIds: imagesIds,
               }

               try {
                    await axios.post(New_Subject, data)
                    toast.success(isVideo ? 'ویدئو جدید ساخته شد.' : 'عنوان جدید ساخته شد.')
                    navigate('/type', { replace: true })
               } catch {
                    // پیام خطا در interceptor اکسios توست می‌شود
               } finally {
                    setLoading(false)
               }

          } else {
               toast.error('لطفا یک تولید کننده انتخاب کنید.')
          }

     }


     return (
          <div className="contentHolder">
               <div className="row">
                    <div className="col-12">
                         <div className="box_radios padding">
                              <form onSubmit={handleSubmitForm} id='formNewPost'>
                                   <p><input name='isTitle' type="text" placeholder="عنوان" required /></p>
                                   <div className="content_flex">

                                        <div className="flexHolder">
                                             <p><input type="text" name='persianTitle' placeholder='نام پارسی' /></p>

                                             <div className='textEditor'>
                                                  <RichTextEditor value={descriptions} onChange={setDescriptions} modules={mod} />
                                             </div>

                                             <PostContentTabs
                                                  links={links}
                                                  setLinks={setLinks}
                                                  refUploadCode={uploadFilesCode}
                                                  updateInfo={updateInfo}
                                                  setUpdateInfo={setUpdateInfo}
                                                  installationGuide={installationGuide}
                                                  setInstallationGuide={setInstallationGuide}
                                                  minimumSystemRequirement={minimumSystemRequirement}
                                                  setMinimumSystemRequirement={setMinimumSystemRequirement}
                                                  recommendedSystemRequirement={recommendedSystemRequirement}
                                                  setRecommendedSystemRequirement={setRecommendedSystemRequirement}
                                                  showSystemRequirements={showSystemRequirements}
                                                  isVideo={isVideo}
                                                  videos={videos}
                                                  setVideos={setVideos}
                                             />

                                        </div>

                                        <div className="flexHolder">

                                             <UploadPoster havePoster={false} pullback={setImageId} setLoading={setLoading} />

                                             <CatsPost data={CategoryList} pullback={setCheckedState} />

                                             <PlatformsPost data={PlatformList} pullback={setPlatformIds} />

                                             <FeaturesPost data={FeatureList} pullback={setFeatures} />

                                             <ProducerSideBar pullback={setSelectedOption} metadataPullback={setMetadata}>
                                                  <p className='w-100'><input type="number" min={1962} max={2040} name='publishDate' placeholder='سال انتشار' required /></p>
                                                  <p className='w-100'><input type="text" name='version' placeholder='ورژن' required /></p>
                                                  <p className='w-100'><input type="number" name='size' step="0.01" placeholder='حجم کل' required={!isVideo} /></p>
                                                  <p className='w-100'>
                                                       <select name="age" id="AGE" required={!isVideo} style={{ width: '100%', backgroundColor: '#fff', padding: '8px', fontSize: '14px' }}>
                                                            <option value=''>رده سنی</option>
                                                            <option value="+3">+3</option>
                                                            <option value="+7">+7</option>
                                                            <option value="+12">+12</option>
                                                            <option value="+15">+15</option>
                                                            <option value="+18">+18</option>
                                                       </select>
                                                  </p>
                                             </ProducerSideBar>

                                             <PendingPost defaultValue={pendingPost} setPendingPost={setPendingPost} datePublish={publishDate} setDatePublish={setPublishDate}>
                                                  <label htmlFor="isPin">
                                                       <input type="checkbox" name="isPin" id="isPin" />
                                                       <span>سنجاق کردن این نوشته در عناوین</span>
                                                  </label>
                                             </PendingPost>

                                             <UploadGallery havePoster={false} pullback={setImagesIds} images={imagesIds} setLoading={setLoading} />


                                             {loading === true ?
                                                  <button type='submit' style={{ width: '100%' }} className='disabled'>لطفا صبر کنید...</button>
                                                  :
                                                  <button type='submit' className='w-100'>ذخیره</button>
                                             }


                                        </div>
                                   </div>
                              </form>
                         </div>
                    </div>
               </div>
          </div>
     )
}
export default NewPost